export type TTheme = typeof defaultTheme;

export const defaultTheme = {
  colors: {
    // PRIMARY
    primary100: "#055A60",
    primaryDisabled: "#78ADB0",

    // GRAY
    gray100: "#2F2F2F",
    grayDark: "#181818",
    gray30: "#E3E3E3",
    gray10: "#F3F3F3",

    // MISC
    white: "#FFFFFF"
  },
  shadows: {
    elevation2: "0px 1px 2px rgba(10, 27, 56, 0.08), 0px 2px 4px rgba(10, 27, 56, 0.12)"
  }
};

export type TDefaultThemeColor = keyof typeof defaultTheme.colors;
